import { render } from "./alarmDigital.vue?vue&type=template&id=2f766c92&scoped=true"
import script from "./alarmDigital.vue?vue&type=script&lang=js"
export * from "./alarmDigital.vue?vue&type=script&lang=js"

import "./alarmDigital.vue?vue&type=style&index=0&id=2f766c92&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f766c92"]])

export default __exports__